import { type Merchant } from '../../core/model/merchant';
import { type Amount, currencyToDisplayString } from '../../core/model/money';
import { Locale } from '../../core/locale/types';
import { useLanguageContext } from '../../core/locale/LanguageContext';
import Receiver from '../Receiver/Receiver';
import './PaymentDetails.css';
import { PaymentType } from '../../core/context/claims';

interface PaymentDetailsProps {
  merchant: Merchant;
  amount?: Amount;
  title?: string;
  locale: Locale;
  paymentType: PaymentType;
  showNewDesign: boolean;
}

function PaymentDetails({
  merchant,
  amount,
  title,
  locale,
  paymentType,
  showNewDesign,
}: PaymentDetailsProps): React.ReactNode {
  const { getLocalizedText } = useLanguageContext();
  const isAmountEmpty = amount === null || amount === undefined || amount.value === '0';
  return (
    <div className="payment-details">
      <Receiver merchant={merchant} paymentType={paymentType} />
      {!isAmountEmpty && (
        <h2 className="payment-details-amount">
          {currencyToDisplayString(amount as Amount, locale)}
          {showNewDesign && ` ${getLocalizedText('paymentTo')} `}
        </h2>
      )}
      {title && isAmountEmpty && (
        <h2 className="payment-details-title">
          {title}
          {showNewDesign && ` ${getLocalizedText('paymentTo')} `}
        </h2>
      )}
    </div>
  );
}

export default PaymentDetails;
